import { Accordion } from '../../../../../components/general/accordion';
import CreateIcon from '@mui/icons-material/Create';
import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { PqrDataInfoProps } from './props';
import { usePqrDataInfo } from './hook';

export const PqrDataInfo = ({ dataInfo }: PqrDataInfoProps) => {
    const { formik } = usePqrDataInfo(dataInfo);

    return (
        <Accordion
            title="DATOS PQR"
            icon={<CreateIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Sucursal de expedición"
                        name="branch"
                        size="small"
                        value={formik.values.branch}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Canal de recepción"
                        name="receptionChannel"
                        size="small"
                        value={formik.values.receptionChannel}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Tipo PQR"
                        name="type"
                        size="small"
                        value={formik.values.type}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Medio"
                        name="half"
                        size="small"
                        value={formik.values.half}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Subtipo DP"
                        name="subtypeDp"
                        size="small"
                        value={formik.values.subtypeDp}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Trámite"
                        name="procedure"
                        size="small"
                        value={formik.values.procedure}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
